import React, { useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter,
} from "@/components/ui/dialog";
import { ShieldAlert } from "lucide-react";
import { toast } from "sonner";

export default function DeletePaiementDialog({ open, onOpenChange, paiement, onDeleted }) {
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post(`/paiements/${paiement.id}/delete-secure`, { password });
      toast.success("Paiement supprimé");
      setPassword("");
      onOpenChange(false);
      onDeleted?.();
    } catch (err) {
      const msg = err.response?.data?.detail;
      const text = typeof msg === "string" ? msg : "Erreur de validation";
      setError(text);
    } finally {
      setLoading(false);
    }
  };

  const close = () => {
    setPassword(""); setError(""); onOpenChange(false);
  };

  if (!paiement) return null;

  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v) close(); else onOpenChange(true); }}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle className="font-display tracking-tight flex items-center gap-2">
            <ShieldAlert size={18} className="text-destructive" /> Confirmer la suppression
          </DialogTitle>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <div className="p-3 bg-red-50 border border-red-200 rounded-sm text-sm">
            <div className="font-semibold text-destructive mb-1">Action irréversible</div>
            <div className="text-muted-foreground">
              Vous êtes sur le point de supprimer un paiement de <span className="font-mono font-semibold text-foreground">
                {new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR" }).format(paiement.montant)}
              </span> ({paiement.methode}).
            </div>
          </div>
          <div>
            <Label className="text-xs uppercase tracking-wider">Confirmez avec votre mot de passe *</Label>
            <Input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              autoFocus
              data-testid="delete-paiement-password"
              className="mt-1 rounded-sm"
            />
          </div>
          {error && <div className="text-sm text-destructive" data-testid="delete-paiement-error">{error}</div>}
          <DialogFooter>
            <Button type="button" variant="outline" onClick={close} className="rounded-sm">Annuler</Button>
            <Button type="submit" disabled={loading} data-testid="delete-paiement-confirm" className="bg-destructive hover:bg-red-700 text-white rounded-sm">
              {loading ? "Vérification…" : "Supprimer"}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
